import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import MainLayout from './components/layout/MainLayout';
import StudyBuilder from './components/StudyBuilder/StudyBuilder';
import MediaManager from './components/MediaManager/MediaManager';
import QuestionManager from './components/QuestionManager/QuestionManager';
import MetadataExplorer from './components/MetadataExplorer/MetadataExplorer';
import InsightConsole from './components/InsightConsole/InsightConsole';
import InsightGenerator from './components/InsightGenerator/InsightGenerator';
import Dashboard from './components/Dashboard/Dashboard';
import ConfigManager from './components/ConfigManager/ConfigManager';
import ServiceStatus from './components/ServiceStatus/ServiceStatus';
import './App.css';

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#722ed1', // Purple theme matching NRG Refract
          borderRadius: 6,
          fontSize: 14,
        },
      }}
    >
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/study-builder" element={<StudyBuilder />} />
            <Route path="/study-builder/:studyId" element={<StudyBuilder />} />
            <Route path="/media-manager/:studyId" element={<MediaManager />} />
            <Route path="/question-manager/:studyId" element={<QuestionManager />} />
            <Route path="/metadata-explorer/:studyId" element={<MetadataExplorer />} />
            <Route path="/insight-console/:studyId" element={<InsightConsole />} />
            <Route path="/insight-generator/:studyId" element={<InsightGenerator />} />
            <Route path="/administration" element={<ConfigManager />} />
            <Route path="/service-status" element={<ServiceStatus />} />
          </Routes>
        </MainLayout>
      </Router>
    </ConfigProvider>
  );
};

export default App; 